import React from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import AddCircle from '@material-ui/icons/AddCircle';
import { Typography } from '@material-ui/core';

const styles = {
  button: {
    padding: 0,
    minWidth: 'auto',
    background: '#fff',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: 'none'
    }
  },
  leftIcon: {
    width: 24,
    height: 24
  },
  textButton: {
    marginLeft: 8,
    fontSize: 14
  }
};

const enhance = compose();

const button = enhance(({ classes, id, onClickAction, disabled, message }) => {
  return (
    <Button
      variant="contained"
      onClick={() => {
        onClickAction(id);
      }}
      className={classes.button}
      disabled={disabled}
    >
      <AddCircle className={classes.leftIcon} color="primary" />
      <Typography color="primary" className={classes.textButton}>
        {message}
      </Typography>
    </Button>
  );
});

export default withRouter(withStyles(styles)(button));
